import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import configData from "../../config/config.json";
import { handleError } from '../../redux/actions/commonStuff';
import { envelopeIconBlack, mobileIcon } from "../../img/font_awesome/font_awesome";

const MAX_EVENTS = 20;

export default function AlertHistorySmall() {
  const history = useHistory();

  const [events, setEvents] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);

  useEffect(() => {
    axios.post(configData.LANDNOTIFICATION_SERVER_URL + "home/alertHistoryMostRecent", { filterText: "", emailAddressId: "", phoneNumberId: "" }, { withCredentials: true })
      .then((response) => {
        setEvents((response.data.content.outgoingEvents || []).slice(0, MAX_EVENTS));
      })
      .catch((error) => {
        handleError(error, history);
      });
  }, [history]);

  const toggleMoreInfo = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <span>Alert History (20 Most Recent)</span>
      </div>

      {/* Content */}
      <div style={styles.content}>
        {events.length === 0 ? (
          <div style={styles.empty}>No history has been recorded yet.</div>
        ) : (
          events.map((event, index) => (
            <div
              key={index}
              style={{
                ...styles.row,
                borderBottom: index === events.length - 1 ? "none" : styles.row.borderBottom,
              }}
            >
              <div style={styles.meta}>
                <span style={styles.metaLabel}>Sent:</span> {event.deliveredTimestampFormatted}
              </div>

              <div style={styles.meta}>
                {event.deliveryMethodType === "PHONE" && (
                  <span style={styles.metaValue}> {mobileIcon} {event.deliveryTarget}</span>
                )}
                {event.deliveryMethodType === "EMAIL" && (
                  <span style={styles.metaValue}> {envelopeIconBlack} {event.deliveryTarget}</span>
                )}
              </div>

              <div style={styles.meta}>
                <span style={styles.metaLabel}>Alert Nickname:</span> {event.alertName}
              </div>

              <div style={styles.meta}>
                <span style={styles.metaLabel}>Criteria:</span> {event.combinedCriteria}
              </div>

              {event.countyCode && (
                <div style={styles.meta}>
                  <span style={styles.metaLabel}>County:</span> {event.countyCode}
                </div>
              )}

              {expandedIndex === index ? (
                <>
                  <div style={styles.meta}>
                    <span style={styles.metaLabel}>Document Number:</span> {event.documentIdentifer}
                  </div>
                  <div style={styles.meta}>
                    <span style={styles.metaLabel}>Matched Criteria:</span> {event.incomingEventCombinedCriteria}
                  </div>
                  <div style={styles.meta}>
                    <span style={styles.metaLabel}>Instrument:</span> {event.documentDescription}
                  </div>
                  <div style={styles.meta}>
                    <span style={styles.metaLabel}>Original Recorded Date:</span> {event.recordedTimestampFormatted}
                  </div>
                  <div style={styles.meta}>
                    <span style={styles.metaLabel}>Activity Recorded Date:</span> {event.eventTimestampFormatted}
                  </div>
                </>
              ) : (
                <button type="button" onClick={() => toggleMoreInfo(index)} style={styles.moreInfoButton}>
                  More Info
                </button>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

// Styles
const styles = {

  container: {
    marginTop: "16px",
    border: "2px solid #114E6B",
    borderRadius: "6px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(17, 78, 107, 0.12)",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 12px",
    backgroundColor: "#114E6B",
    fontWeight: "bold",
    color: "white",
  },

  content: {
    padding: "4px 12px",
    backgroundColor: "white",
    fontSize: "14px",
    lineHeight: "1.5",
    maxHeight: "360px",
    overflowY: "auto",
  },

  empty: {
    color: "#444",
    fontWeight: "bold",
    padding: "8px 0",
  },

  row: {
    padding: "10px 0",
    borderBottom: "2px solid #adb5bd",
  },

  meta: {
    marginTop: "4px",
    color: "#444",
    fontSize: "13px",
  },

  metaLabel: {
    fontWeight: "bold",
  },

  metaValue: {
    marginLeft: "4px",
  },

  moreInfoButton: {
    marginTop: "6px",
    background: "none",
    border: "none",
    color: "#114E6B",
    fontWeight: "bold",
    fontSize: "13px",
    cursor: "pointer",
    padding: 0,
    textDecoration: "underline",
  },

};
